<template>
    <div class="all-section-area">
        <MainHeaderTwo class="header-style-two" />
        <main class="main-content-wrap style-two">
            <WelcomeBack />
            <HrManagementContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeaderTwo from '../Layouts/MainHeaderTwo'
import WelcomeBack from '../Dashboards/HrManagement/WelcomeBack'
import HrManagementContent from '../Dashboards/HrManagement/HrManagementContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'HrManagementPage',
    components: {
        MainHeaderTwo,
        WelcomeBack,
        HrManagementContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>